import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useIsPageVisible } from '@/hooks/useIsPageVisible';
import { useIntersectionObserver } from 'usehooks-ts';
export const useAutoPlayVideoOnVisible = () => {
  const $ = _c(10);
  const [videoElement, setVideoElement] = useState(null);
  const isPageVisible = useIsPageVisible();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isIntersecting,
    ref
  } = useIntersectionObserver(t0);
  let t1;
  if ($[1] !== isIntersecting || $[2] !== videoElement) {
    t1 = () => {
      if (!videoElement) {
        return;
      }
      if (isIntersecting) {
        videoElement.play().catch(_temp);
      } else {
        videoElement.pause();
      }
    };
    $[1] = isIntersecting;
    $[2] = videoElement;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isIntersecting || $[5] !== isPageVisible || $[6] !== videoElement) {
    t2 = [videoElement, isIntersecting, isPageVisible];
    $[4] = isIntersecting;
    $[5] = isPageVisible;
    $[6] = videoElement;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== ref) {
    const handleRef = element => {
      ref(element);
      setVideoElement(element);
    };
    t3 = {
      handleRef
    };
    $[8] = ref;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp() {}